export const koshaInfo = {
  annamaya: {
    name: "Annamaya Kosha",
    subtitle: "Physical Layer",
    description: "The physical dimension of your relationship - touch, presence, and bodily connection.",
    color: "#8B4513",
    icon: "🌍"
  },
  pranamaya: {
    name: "Pranamaya Kosha",
    subtitle: "Energy Layer",
    description: "The vital energy exchange between partners - the life force that flows in shared moments.",
    color: "#FF6B35",
    icon: "⚡"
  },
  manomaya: {
    name: "Manomaya Kosha",
    subtitle: "Mind Layer",
    description: "The mental and emotional connection - thoughts, feelings, and communication patterns.",
    color: "#1E3A5F",
    icon: "🧠"
  },
  vijnanamaya: {
    name: "Vijnanamaya Kosha",
    subtitle: "Wisdom Layer",
    description: "The intellectual and growth dimension - shared values, mutual support for evolution.",
    color: "#6B21A8",
    icon: "💡"
  },
  anandamaya: {
    name: "Anandamaya Kosha",
    subtitle: "Bliss Layer",
    description: "The spiritual and bliss dimension - the deepest joy and sacred connection in your bond.",
    color: "#D4A853",
    icon: "✨"
  }
};

export const questions = [
  // Annamaya Kosha - Physical Layer (5 questions)
  {
    id: 1,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How often do you and your spouse engage in physical touch or intimacy (holding hands, hugs, kisses)?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 2,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "Do you feel comfortable and at ease in your spouse's physical presence?",
    options: [
      { value: 1, label: "Very uncomfortable" },
      { value: 2, label: "Somewhat uncomfortable" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Comfortable" },
      { value: 5, label: "Completely at ease" }
    ]
  },
  {
    id: 3,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How frequently do you engage in joint physical activities like walking or yoga with your spouse?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 4,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "Do you notice physical tension or discomfort when near your spouse?",
    options: [
      { value: 5, label: "Never" },
      { value: 4, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 2, label: "Often" },
      { value: 1, label: "Always" }
    ]
  },
  {
    id: 5,
    kosha: 'annamaya',
    koshaName: 'Annamaya Kosha',
    koshaDescription: 'Physical Layer',
    question: "How satisfied are you with your shared physical health and fitness routines?",
    options: [
      { value: 1, label: "Very dissatisfied" },
      { value: 2, label: "Dissatisfied" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Satisfied" },
      { value: 5, label: "Very satisfied" }
    ]
  },
  // Pranamaya Kosha - Energy Layer (5 questions)
  {
    id: 6,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "After spending time with your spouse, do you typically feel energized or drained?",
    options: [
      { value: 1, label: "Very drained" },
      { value: 2, label: "Somewhat drained" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Somewhat energized" },
      { value: 5, label: "Very energized" }
    ]
  },
  {
    id: 7,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "How well do your daily rhythms and energy levels align with your spouse's?",
    options: [
      { value: 1, label: "Completely misaligned" },
      { value: 2, label: "Mostly different" },
      { value: 3, label: "Somewhat aligned" },
      { value: 4, label: "Well aligned" },
      { value: 5, label: "Perfectly synchronized" }
    ]
  },
  {
    id: 8,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "Do you feel a natural energy flow during intimate moments with your spouse?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 9,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "How often do you practice breathwork or energy-balancing activities together?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 10,
    kosha: 'pranamaya',
    koshaName: 'Pranamaya Kosha',
    koshaDescription: 'Energy Layer',
    question: "Does your spouse's presence recharge or deplete your vitality?",
    options: [
      { value: 1, label: "Always depletes" },
      { value: 2, label: "Often depletes" },
      { value: 3, label: "Neutral" },
      { value: 4, label: "Often recharges" },
      { value: 5, label: "Always recharges" }
    ]
  },
  // Manomaya Kosha - Mind Layer (5 questions)
  {
    id: 11,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How frequently do you have arguments or unresolved tensions with your spouse?",
    options: [
      { value: 1, label: "Daily" },
      { value: 2, label: "Several times a week" },
      { value: 3, label: "Weekly" },
      { value: 4, label: "Rarely" },
      { value: 5, label: "Almost never" }
    ]
  },
  {
    id: 12,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "Can you openly share your deepest fears and vulnerabilities with your spouse?",
    options: [
      { value: 1, label: "Never - I hide everything" },
      { value: 2, label: "Rarely - Only surface level" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often - Most things" },
      { value: 5, label: "Always - Complete openness" }
    ]
  },
  {
    id: 13,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How well does your spouse understand your emotional needs without you explaining?",
    options: [
      { value: 1, label: "Not at all" },
      { value: 2, label: "Slightly" },
      { value: 3, label: "Moderately" },
      { value: 4, label: "Very well" },
      { value: 5, label: "Completely - We're in sync" }
    ]
  },
  {
    id: 14,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "How often do emotional triggers from past experiences affect your interactions?",
    options: [
      { value: 1, label: "Always" },
      { value: 2, label: "Often" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Rarely" },
      { value: 5, label: "Never" }
    ]
  },
  {
    id: 15,
    kosha: 'manomaya',
    koshaName: 'Manomaya Kosha',
    koshaDescription: 'Mind Layer',
    question: "Do you feel mentally calm and focused after conversations with your spouse?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  // Vijnanamaya Kosha - Wisdom Layer (5 questions)
  {
    id: 16,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "Do you and your spouse actively support each other's personal growth and goals?",
    options: [
      { value: 1, label: "We oppose each other" },
      { value: 2, label: "Rarely supportive" },
      { value: 3, label: "Sometimes supportive" },
      { value: 4, label: "Usually supportive" },
      { value: 5, label: "Each other's biggest champions" }
    ]
  },
  {
    id: 17,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How aligned are your core values and life philosophy with your spouse's?",
    options: [
      { value: 1, label: "Completely different" },
      { value: 2, label: "Mostly different" },
      { value: 3, label: "Some overlap" },
      { value: 4, label: "Mostly aligned" },
      { value: 5, label: "Deeply aligned" }
    ]
  },
  {
    id: 18,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "Do you learn and grow together through challenges in your relationship?",
    options: [
      { value: 1, label: "Challenges divide us" },
      { value: 2, label: "We struggle separately" },
      { value: 3, label: "Sometimes we learn" },
      { value: 4, label: "Often grow together" },
      { value: 5, label: "Every challenge strengthens us" }
    ]
  },
  {
    id: 19,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "How often do you discuss spiritual or philosophical ideas meaningfully?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 20,
    kosha: 'vijnanamaya',
    koshaName: 'Vijnanamaya Kosha',
    koshaDescription: 'Wisdom Layer',
    question: "Does your spouse intuitively grasp your long-term vision for life?",
    options: [
      { value: 1, label: "Not at all" },
      { value: 2, label: "Slightly" },
      { value: 3, label: "Moderately" },
      { value: 4, label: "Very well" },
      { value: 5, label: "Perfectly" }
    ]
  },
  // Anandamaya Kosha - Bliss Layer (5 questions)
  {
    id: 21,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "On a scale, how blissful and fulfilling does your relationship feel overall?",
    options: [
      { value: 1, label: "1-2: Very unfulfilling" },
      { value: 2, label: "3-4: Somewhat unfulfilling" },
      { value: 3, label: "5-6: Neutral" },
      { value: 4, label: "7-8: Fulfilling" },
      { value: 5, label: "9-10: Deeply blissful" }
    ]
  },
  {
    id: 22,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "Do you experience moments of deep spiritual connection or transcendence together?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Very rarely" },
      { value: 3, label: "Occasionally" },
      { value: 4, label: "Frequently" },
      { value: 5, label: "Regularly - It's our foundation" }
    ]
  },
  {
    id: 23,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "How often do you feel unconditional joy and peace in each other's presence?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 24,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "Do shared silences bring profound contentment?",
    options: [
      { value: 1, label: "Never" },
      { value: 2, label: "Rarely" },
      { value: 3, label: "Sometimes" },
      { value: 4, label: "Often" },
      { value: 5, label: "Always" }
    ]
  },
  {
    id: 25,
    kosha: 'anandamaya',
    koshaName: 'Anandamaya Kosha',
    koshaDescription: 'Bliss Layer',
    question: "How aligned is your sense of ultimate purpose or dharma with your spouse's?",
    options: [
      { value: 1, label: "Completely misaligned" },
      { value: 2, label: "Mostly different" },
      { value: 3, label: "Somewhat aligned" },
      { value: 4, label: "Well aligned" },
      { value: 5, label: "Perfectly united" }
    ]
  }
];

export const calculateResults = (answers) => {
  const koshaScores = {
    annamaya: [],
    pranamaya: [],
    manomaya: [],
    vijnanamaya: [],
    anandamaya: []
  };

  questions.forEach(q => {
    if (answers[q.id]) {
      koshaScores[q.kosha].push(answers[q.id]);
    }
  });

  const calculatePercentage = (scores) => {
    if (scores.length === 0) return 0;
    const avg = scores.reduce((a, b) => a + b, 0) / scores.length;
    return Math.round((avg / 5) * 100);
  };

  const annamaya = calculatePercentage(koshaScores.annamaya);
  const pranamaya = calculatePercentage(koshaScores.pranamaya);
  const manomaya = calculatePercentage(koshaScores.manomaya);
  const vijnanamaya = calculatePercentage(koshaScores.vijnanamaya);
  const anandamaya = calculatePercentage(koshaScores.anandamaya);

  const overall = Math.round((annamaya + pranamaya + manomaya + vijnanamaya + anandamaya) / 5);

  return { annamaya, pranamaya, manomaya, vijnanamaya, anandamaya, overall };
};

export const getInsight = (kosha, score) => {
  const insights = {
    annamaya: {
      high: {
        message: "Your physical connection is strong! You've cultivated a beautiful embodied presence together.",
        quote: "The body is the temple of the soul. You honor this temple together."
      },
      low: {
        message: "Your physical connection needs nurturing. Consider daily rituals of touch - holding hands, embracing, or practicing yoga together.",
        quote: "As the Gita teaches: 'The body is the field; tend to it with love.'"
      }
    },
    pranamaya: {
      high: {
        message: "Your energetic harmony is remarkable! You naturally sync and uplift each other's vital force.",
        quote: "Your prana flows as one river - this is the dance of Shiva and Shakti."
      },
      low: {
        message: "Your energy exchange may need attention. Try breathing exercises together or aligning daily routines.",
        quote: "The Gita says: 'When prana is steady, the mind becomes steady.' Breathe together."
      }
    },
    manomaya: {
      high: {
        message: "Your mental and emotional bond is deep! Communication flows with understanding and empathy.",
        quote: "Like Arjuna and Krishna, you've mastered the dialogue of hearts."
      },
      low: {
        message: "Communication barriers exist. Practice active listening and create safe spaces for vulnerable sharing.",
        quote: "Krishna advises: 'Speak truth that is pleasant, not truth that is unpleasant.' Choose words wisely."
      }
    },
    vijnanamaya: {
      high: {
        message: "You're intellectual and spiritual allies! Supporting each other's growth is your shared dharma.",
        quote: "You embody the Gita's teaching: 'Yoga is skill in action' - you grow skillfully together."
      },
      low: {
        message: "Mutual growth support could strengthen. Discuss dreams openly and become each other's champions.",
        quote: "The Gita reminds: 'Perform your duty equipoised, abandoning attachment to success or failure.'"
      }
    },
    anandamaya: {
      high: {
        message: "Your spiritual bond is transcendent! Like Krishna's guidance, your love touches the divine.",
        quote: "You've found what the Gita promises: 'The yogi finds infinite bliss.' Your union is sacred."
      },
      low: {
        message: "The bliss layer awaits cultivation. Consider spiritual practices together - meditation, gratitude rituals, or temple visits.",
        quote: "As Krishna teaches: 'The wise see the same in all beings.' See the divine in your partner."
      }
    }
  };

  const isStrength = score >= 70;
  return {
    type: isStrength ? 'strength' : 'opportunity',
    message: insights[kosha][isStrength ? 'high' : 'low'].message,
    quote: insights[kosha][isStrength ? 'high' : 'low'].quote
  };
};
